import React from 'react';
import { TApiOrderDetails } from "../../../api/endpoints/Order";

interface Props {
  order: TApiOrderDetails;
}

const MaxChargeCostPerCostingVersion = {
  v1: null,
  v2: null,
  v3: {
    basic: '€70,000',
    withHighFrequency: '€78,000'
  },
  v4: {
    basic: '€47,500',
    withHighFrequency: '€55,500'
  },
  v5: {
    basic: '€47,500',
    withHighFrequency: '€55,500'
  },
  v6: null
}

const MaxChargeWarning = (props: Props) => {
  const { order } = props;

  const cost = MaxChargeCostPerCostingVersion[order.cost.version];

  if (!cost) {
    return null;
  }

  return (
    <div className="alert alert-warning">
      <p>
        This data configuration would require a Maximum Charge licence agreement,
        which is not subject to discounts.
      </p>

      <p>
        The Information Cost of the Maximum Charge Licence without High Frequency Products
        (hourly data and 06/18 forecast runs) is: {cost.basic} per year.
      </p>

      <p style={{ margin: 0 }}>
        The Information Cost of the Maximum Charge Licence with High Frequency Products
        (hourly data and 06/18 forecast runs) is {cost.withHighFrequency} per year.
      </p>
    </div>
  )
}

export default MaxChargeWarning;
